export default __webpack_public_path__ + "static/webdev-1ce4500bacaffae62ae8d25271455085.jpeg";